module.exports = __webpack_public_path__ + "img/four2Red.0dc01cb3.jpg";